import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OcrHistoryComponent } from '../../components/ocr-history/ocr-history.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { OcrDialogComponent } from '../../components/ocr-dialog/ocr-dialog.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-ocr-history-page',
  standalone: true,
  imports: [CommonModule, OcrHistoryComponent, MatDialogModule, RouterModule],
  styles: [`
    :host {
      display: block;
      height: 100%;
    }
  `],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="h-full flex flex-col p-3 overflow-hidden bg-ds-surface">
      <main class="flex-1 overflow-hidden relative">
        <app-ocr-history class="h-full block" (uploadClick)="openOcrDialog()"></app-ocr-history>
      </main>
    </div>
  `
})
export class OcrHistoryPageComponent implements OnInit {
  private dialogRef: any;

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
  }

  openOcrDialog(): void {
    this.dialogRef = this.dialog.open(OcrDialogComponent, {
      width: '90vw',
      maxWidth: '1600px',
      height: '90vh',
      panelClass: 'ocr-dialog-container',
      disableClose: false
    });

    this.dialogRef.componentInstance.close.subscribe(() => {
      this.dialogRef.close();
    });
  }

  closeOcrDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
